/**
 * @generated SignedSource<<066b187db59993ebd95467eea8c72ba5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type labelCategoryRow_company$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"labelRow_company" | "newLabelRow_company">;
  readonly " $fragmentType": "labelCategoryRow_company";
};
export type labelCategoryRow_company$key = {
  readonly " $data"?: labelCategoryRow_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelCategoryRow_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelCategoryRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "labelRow_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newLabelRow_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "119da035b0d473b907b0149f236e0faa";

export default node;
